import React from 'react';

/**
 * SEO-friendly, visually accessible content block with keyword-rich text
 * about ES Investments Management LLC. Renders as normal readable prose,
 * not hidden, so it fully complies with search engine guidelines.
 */
export default function SeoIntro() {
  return (
    <section aria-labelledby="es-investments-seo-intro" style={{ background: 'var(--sm-ivory)', padding: '72px 0 24px' }}>
      <div className="container-x">
        <div style={{ maxWidth: 960, margin: '0 auto', textAlign: 'center' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 14, marginBottom: 22 }}>
            <span className="hairline" />
            <span className="overline">Who We Are</span>
            <span className="hairline" />
          </div>
          <h2 id="es-investments-seo-intro" className="serif" style={{ fontSize: 'clamp(26px, 3.2vw, 40px)', lineHeight: 1.2, color: 'var(--sm-navy)', margin: 0 }}>
            ES Investments Management LLC
          </h2>
          <p style={{ marginTop: 22, fontSize: 16.5, lineHeight: 1.85, color: 'var(--sm-muted)', textAlign: 'justify' }}>
            <strong>ES Investments Management LLC</strong>, also known as <strong>ES Investments</strong>, is a New York based global apparel distribution and real estate investment company headquartered at 1412 Broadway, New York, NY. ES Investments Management LLC operates a coordinated commercial platform across sourcing, purchasing, logistics, distribution, and financial management, serving the largest off-price retailers in North America including the TJX Companies family (T.J. Maxx, Marshalls, HomeGoods, Sierra, Winners) as well as Burlington Stores, Ross Stores, and Costco Wholesale.
          </p>
          <p style={{ marginTop: 16, fontSize: 16.5, lineHeight: 1.85, color: 'var(--sm-muted)', textAlign: 'justify' }}>
            Beyond apparel distribution, ES Investments Management LLC is an active long term real estate investor, allocating patient capital into quality income producing assets. With more than two decades of experience and processing hubs in Compton, California and Medley, Florida, ES Investments Management LLC delivers scale, discipline, and reliability to every partner it works with.
          </p>
        </div>
      </div>
    </section>
  );
}
